import Analytics from '@/core/Analytics'
import { getCLS, getFID, getLCP, getTTFB, getFCP } from 'web-vitals'
import { WEBPERFORMANCE_INDICATOR, WEBPERFORMANCE_ALPHA } from './config'

const typeMap: any = {
  TTFB: WEBPERFORMANCE_INDICATOR,
  FCP: WEBPERFORMANCE_INDICATOR,
  LCP: WEBPERFORMANCE_INDICATOR,
  FID: WEBPERFORMANCE_ALPHA,
  CLS: WEBPERFORMANCE_ALPHA
}

interface LogType {
  name: string;
  delta: number;
}

// performanceMark 伪造，firebase自动上传
function logDelta({ name, delta }: LogType): void {
  if (window.performance) {
    if (typeMap[name]) {
      Analytics.track(typeMap[name], {
        type: name,
        time_common: Math.round(name === 'CLS' ? delta * 1000 : delta)
      })
    }
  }
  // console.log(`${name} matching  changed by ${delta}`)
}

// web-vitals采集性能指标事件
export const startMonitor = () => {
  try {
    getTTFB(logDelta)
    getFCP(logDelta)
    getLCP(logDelta)
    getFID(logDelta)
    getCLS(logDelta)
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e)
  }
}
